import { useQuery } from 'apollo-3';

import { useClassroomContext } from 'Context/ClassroomContext';
import { classroomTimeStatus } from 'GraphQL/query/Classroom.query';

// Cache only: the classroom keeps this up to date, so no extra request here.
// Skipped without classroomTimeId because the API reports false for a missing id.
const useIsClassroomTimeUp = () => {
  const { classroomTimeId } = useClassroomContext();
  const { data } = useQuery(classroomTimeStatus, {
    variables: { classroomTimeId },
    fetchPolicy: 'cache-only',
    skip: !classroomTimeId,
  });
  return data?.classroomTime?.isValidRemainingTime === false;
};

export default useIsClassroomTimeUp;
